"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBooksCoverPrintable;
const Product_1 = require("../../models/Product");
const numbers_1 = require("../..//helpers/numbers");
const either_1 = require("../../types/either");
const designs_1 = require("../designs");
const EditableTextLayer_1 = require("../../models/layers/EditableTextLayer");
const _1 = require("./");
const createPrintable_1 = __importDefault(require("./createPrintable"));
function createBooksCoverPrintable(sku, userId, projectId, creationDate, template, hammerCategory, interiorPageCount, printableId) {
  // If the hammer category is a type of spread book, the designs in hammer are defined and filtered based on *spread count* not page count.
  // So in order to find the appropriate designs, we need to divide the page count by 2 to get spread count
  const interiorPrintableCount = (0, Product_1.isSpreadBooksCategory)(hammerCategory) ? interiorPageCount / 2 : interiorPageCount;
  const findCoverDesignResult = (0, designs_1.findCoverDesign)(template.designs, interiorPrintableCount);
  if (findCoverDesignResult.isLeft()) {
    return (0, either_1.left)(findCoverDesignResult.value);
  }
  const layersResult = (0, designs_1.getLayersForDesign)(sku, template, findCoverDesignResult.value);
  const layers = Array.isArray(layersResult.value) ? layersResult.value : [];
  if (layersResult.isLeft()) {
    return (0, either_1.left)(layersResult.value);
  }
  const createCoverPrintableResult = (0, createPrintable_1.default)(sku, userId, projectId, findCoverDesignResult.value.id, layersResult.value, template, printableId, creationDate);
  if (createCoverPrintableResult.isLeft()) {
    return (0, either_1.left)(createCoverPrintableResult.value);
  }
  const coverPrintable = createCoverPrintableResult.value;
  // If the template has coverSurfaces - need to replace the surface on the printable with the appropriate coverSurface
  if (interiorPageCount && template.coverSurfaces) {
    // Look for coverSurface with appropriate range for the page count of this book
    const newCoverSurface = template.coverSurfaces.find(coverSurf => coverSurf.pageCount && (0, numbers_1.inRange)(interiorPageCount, coverSurf.pageCount.min, coverSurf.pageCount.max));
    // If a coverSurface was found, put it in the cover printable
    if (newCoverSurface) {
      coverPrintable.surface = newCoverSurface;
    }
  }
  layers.map(layer => {
    // In case defaultData.content exists, we need to create userData with that information. That's why we call this function
    if ((0, EditableTextLayer_1.isEditableTextLayer)(layer) && layer.defaultData.content && layer.defaultData.content !== '' && layer.defaultData.content !== undefined) {
      (0, _1.createDefaultLayers)(layer, coverPrintable.surface);
    }
  });
  return (0, either_1.right)(coverPrintable);
}